import React, { Component } from 'react';
import { logo } from '../assets';

const styles = {
  rightItem: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  header: {
    backgroundColor: 'white',
    left: 0,
    right: 0,
    height: 80,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 25,
    paddingRight: 25,
    borderBottomColor: '#E6E6E6',
    borderBottomWidth: 1,
    borderBottomStyle: 'solid'
  }
};

export default class AppHeader extends Component {
  
  static propTypes = {
    renderRightItem: React.PropTypes.func
  };
  
  render() {
    return (
      <div style={styles.header}>
        <img src={logo} />
        {this.props.renderRightItem ?
         (
           <div style={styles.rightItem}>
             {this.props.renderRightItem()}
           </div>
         ) :null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/base-components/app-header.js